import { render } from "./NewExerciseView.vue?vue&type=template&id=6a9d7e48&ts=true"
import script from "./NewExerciseView.vue?vue&type=script&lang=ts"
export * from "./NewExerciseView.vue?vue&type=script&lang=ts"

import exportComponent from "/srv/stamincasa/stamincasa-matematica/frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__